/**
 * DevExtreme (esm/__internal/grids/new/grid_core/filtering/filter_sync/utils.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    removeFieldConditionsFromFilter,
    syncFilters
} from "../../../../../filter_builder/m_utils";
export const getFilterValues = filterConditions => {
    if (1 !== filterConditions.length) {
        return
    }
    const filterCondition = filterConditions[0];
    if (!filterCondition) {
        return
    }
    const value = filterCondition[2];
    const hasArrayValue = Array.isArray(value);
    return hasArrayValue ? value : [value]
};
export const getFilterType = filterConditions => {
    if (1 !== filterConditions.length) {
        return
    }
    const filterCondition = filterConditions[0];
    if (!filterCondition) {
        return
    }
    const selectedFilterOperation = filterCondition[1];
    switch (selectedFilterOperation) {
        case "anyof":
        case "=":
            return "include";
        case "noneof":
        case "<>":
            return "exclude";
        default:
            return
    }
};
export const getConditionFromHeaderFilter = _ref => {
    let {
        type: type,
        columnId: columnId,
        filterType: filterType,
        filterValues: filterValues
    } = _ref;
    const [firstFilterItem] = filterValues;
    switch (true) {
        case "single-value" === type && "exclude" === filterType:
            return [columnId, "<>", firstFilterItem];
        case "single-value" === type && "include" === filterType:
            return [columnId, "=", firstFilterItem];
        case "values-or-condition" === type && "exclude" === filterType:
            return [columnId, "noneof", filterValues];
        case "values-or-condition" === type && "include" === filterType:
            return [columnId, "anyof", filterValues];
        default:
            return null
    }
};
export const mergeFilterPanelWithHeaderFilterValues = (filterPanelValue, headerFilterInfoArray) => headerFilterInfoArray.reduce(((result, info) => {
    const value = getConditionFromHeaderFilter(info);
    return value ? syncFilters(result, value) : removeFieldConditionsFromFilter(result, info.columnId)
}), filterPanelValue);
